import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./auth/AuthContext";
import { AdminLayout } from "./components/AdminLayout";
import { AccountPage } from "./pages/AccountPage";
import { BlogIndexPage, BlogPostPage } from "./pages/BlogPage";
import { GuestsPage } from "./pages/GuestsPage";
import { LoginPage } from "./pages/LoginPage";
import { MessagesPage } from "./pages/MessagesPage";
import { MorePage } from "./pages/MorePage";
import { PublicHome } from "./pages/PublicHome";
import { ReservationsPage } from "./pages/ReservationsPage";
import { ReviewPage } from "./pages/ReviewPage";
import { TasksPage } from "./pages/TasksPage";
import { TodayPage } from "./pages/TodayPage";
import { WebsitePage } from "./pages/WebsitePage";
import "./styles.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<PublicHome />} />
          <Route path="/es" element={<PublicHome />} />
          <Route path="/blog" element={<BlogIndexPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/es/blog" element={<BlogIndexPage />} />
          <Route path="/es/blog/:slug" element={<BlogPostPage />} />
          <Route path="/review/:token" element={<ReviewPage />} />
          <Route path="/staff/login" element={<LoginPage />} />
          <Route path="/staff" element={<AdminLayout />}>
            <Route index element={<TodayPage />} />
            <Route path="calendar" element={<ReservationsPage />} />
            <Route path="guests" element={<GuestsPage />} />
            <Route path="messages" element={<MessagesPage />} />
            <Route path="tasks" element={<TasksPage />} />
            <Route path="website" element={<WebsitePage />} />
            <Route path="more" element={<MorePage />} />
            <Route path="account" element={<AccountPage />} />
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
